import React from 'react'
import { BrowserRouter, Route, Switch, useHistory, useLocation } from 'react-router-dom'

import { Basic } from 'layouts'
import { ChangePassword, RecoverPassword } from 'scenes/login/recoverPassword'
import {
  Account,
  Albums,
  Compositions,
  Events,
} from 'scenes'
import Composition from 'scenes/compositions/composition'
import CompositionsNew from 'scenes/compositions/new'
import Login from 'scenes/login'
import Signup, { ConfirmEmail } from 'scenes/signup'
import useAuthStore from 'store/auth'
import ViewAlbumsScene from 'scenes/albums/view'


const ResetScrollPage = props => {
  const { pathname } = useLocation()

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return props.children
}


export const Authenticated = props => {
  const { isLogged } = useAuthStore()
  const location = useLocation()
  const history = useHistory()
  const redirect = props.redirect
  const redirectUrl = props.redirectUrl

  React.useEffect(() => {
    if (isLogged === false && redirect) {
      history.push('/login?redirect=' + (redirectUrl || location.pathname + location.search))
    }
  }, [isLogged, redirect, redirectUrl]) // eslint-disable-line

  if (isLogged === null) return null

  return props.children
}

Authenticated.defaultProps = {
  redirect: true,
}


export default function Routes(props) {
  const { getUser } = useAuthStore()

  React.useEffect(() => {
    getUser()

  }, []) // eslint-disable-line

  return (
    <BrowserRouter>
      <ResetScrollPage>
        <Switch>
          <Route path='/compositions/new' exact component={CompositionsNew}/>
          <Basic>
            <Route path='/compositions/s/:s' exact component={Compositions}/>
            <Route path='/compositions/:compositionId' exact component={Composition}/>
            <Route path='/' exact component={Compositions}/>
            <Route path='/albums/s/:s' exact component={Albums}/>
            <Route path='/albums' exact component={Albums}/>
            <Route exact path={'/albums/:id'} component={ViewAlbumsScene} />
            <Route path='/users/:userId/compositions/s/:s' exact component={Compositions}/>
            <Route path='/users/:userId/compositions' exact component={Compositions}/>
            <Route path='/users/:userId/albums/s/:s' exact component={Albums}/>
            <Route path='/users/:userId/albums' exact component={Albums}/>
            <Route path='/events' exact component={Events}/>
            <Route path='/account' component={Account}/>
            <Route path='/login' component={Login}/>
            <Route path='/signup' component={Signup}/>
            <Route path='/confirm-account/:token' component={ConfirmEmail}/>
            <Route exact path='/recover-password/change/:uid/:token/' component={ChangePassword}/>
            <Route exact path='/recover-password/' component={RecoverPassword}/>
          </Basic>
        </Switch>
      </ResetScrollPage>
    </BrowserRouter>
  )
}
